import http from '@/utils/http';

export default {
    save: data => {
        return http({url:'/api/admin/v1/storage/save',data,tip:true,loading:true}).then(r => r);
    },
    delete: data => {
        return http({url:'/api/admin/v1/storage/delete',data,tip:true,loading:true}).then(r => r);
    },
    list: data => {
        return http({url:'/api/admin/v1/storage/list',data}).then(r => r);
    },
    listAll: () => {
        return http({url:'/api/admin/v1/storage/listAll'}).then(r => r);
    },
}